import React from 'react';

const PieChart = ({ data, size = 200, showLabels = false }) => {
  const filteredData = data
    .map(item => ({ ...item, value: Number(item.value) || 0 }))
    .filter(item => item.value > 0);

  const total = filteredData.reduce((sum, item) => sum + item.value, 0);

  if (total === 0 || filteredData.length === 0) {
    return (
      <div className="flex items-center justify-center" style={{ width: size, height: size, minHeight: size }}>
        <span className="text-gray-400 text-sm">Aucune donnée</span>
      </div>
    );
  }

  let currentAngle = -90;
  const radius = size / 2 - 10;
  const centerX = size / 2;
  const centerY = size / 2;

  const paths = filteredData.map((item, index) => {
    const percentage = (item.value / total) * 100;
    let angle = (percentage / 100) * 360;

    if (angle >= 359.9) {
      angle = 360;
    }

    const startAngle = currentAngle;
    const endAngle = currentAngle + angle;

    const x1 = centerX + radius * Math.cos((startAngle * Math.PI) / 180);
    const y1 = centerY + radius * Math.sin((startAngle * Math.PI) / 180);
    const x2 = centerX + radius * Math.cos((endAngle * Math.PI) / 180);
    const y2 = centerY + radius * Math.sin((endAngle * Math.PI) / 180);

    const largeArcFlag = angle > 180 ? 1 : 0;

    let pathData;
    if (angle >= 360) {
      pathData = `M ${centerX} ${centerY} m -${radius} 0 a ${radius} ${radius} 0 1 1 ${radius * 2} 0 a ${radius} ${radius} 0 1 1 -${radius * 2} 0`;
    } else {
      pathData = `M ${centerX} ${centerY} L ${x1.toFixed(2)} ${y1.toFixed(2)} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2.toFixed(2)} ${y2.toFixed(2)} Z`;
    }

    const midAngle = (startAngle + endAngle) / 2;
    const labelRadius = radius * 0.7;
    const labelX = centerX + labelRadius * Math.cos((midAngle * Math.PI) / 180);
    const labelY = centerY + labelRadius * Math.sin((midAngle * Math.PI) / 180);

    currentAngle = endAngle;

    return (
      <g key={`slice-${index}-${item.label}`}>
        <path
          d={pathData}
          fill={item.color || '#2563eb'}
          stroke="#fff"
          strokeWidth="2"
          strokeLinejoin="round"
          style={{
            fill: item.color || '#2563eb',
            opacity: 1
          }}
        />
        {showLabels && (
          <text
            x={labelX}
            y={labelY}
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#fff"
            fontSize="12"
            fontWeight="bold"
            style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.5)' }}
          >
            {percentage.toFixed(1)}%
          </text>
        )}
      </g>
    );
  });

  if (paths.length === 0) {
    return (
      <div className="flex items-center justify-center" style={{ width: size, height: size }}>
        <span className="text-gray-400 text-sm">Aucune donnée</span>
      </div>
    );
  }

  return (
    <div
      className="pie-chart-container"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        flexShrink: 0,
        margin: '0 auto'
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        xmlns="http://www.w3.org/2000/svg"
        style={{
          display: 'block',
          width: `${size}px`,
          height: `${size}px`,
          overflow: 'visible'
        }}
      >
        {paths}
      </svg>
    </div>
  );
};

export default PieChart;
